module.exports = __webpack_public_path__ + "img/hochzeit_tanz_ocular.e7de431c.jpg";